module.exports = __webpack_public_path__ + "img/winter.4e456c6e.png";